const Regex = {
    AccountName: /^(?!\.)[a-z1-5.]{1,12}(?!\.\.)$(?<!\.)/,
    PrivateKey: /^[0-9A-Za-z]{51}$/,
    PublicKey: /^INE[0-9A-Za-z]{50}$/,
    CompositionName: /^.{1,32}$/,
    // Allow letters, digits, underscore and space, 1-25 chars
    FieldName: /^[A-Za-z0-9_ ]{1,25}$/
};

module.exports = Regex;